import moment from 'moment';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import type { DayNumber } from '@app/components/Calendars/components/DayNumber/types';
import { daysShort } from '@app/pages/TasksList/constants/dates';
import { useTaskListContext } from '@app/providers/TaskListProvider';

import type { Moment } from 'moment';

export const useWeeklyCalendar = () => {
  const {
    activeTab,
    currentDate,
    toPrevDate,
    toNextDate,
    weeklyTasks,
    isCalendarsTabsLoading,
    createTaskForRange,
    openPreviewTaskModal,
  } = useTaskListContext();

  const [, setSearchParams] = useSearchParams();
  const toPrevWeek = toPrevDate;
  const toNextWeek = toNextDate;

  const getDayNumbers = useCallback(() => {
    if (activeTab !== 'week') {
      return [];
    }

    const { year, week } = currentDate;
    const weekDays = Array.from({ length: 7 }, (_, i) =>
      moment()
        .year(year)
        .week(week)
        .isoWeekday(i + 1)
    );

    const dayNumbers = weekDays.map((date: Moment) => {
      const year = date.year().toString();
      const month = (date.month() + 1).toString();
      const dayNumber = date.date();
      const day = dayNumber.toString();
      const isToday = date.isSame(moment(), 'day');
      const title = daysShort[date.isoWeekday() as keyof typeof daysShort];
      const onClick = () => setSearchParams({ tab: 'day', year, month, day });

      const clickable = true;
      return { dayNumber, isToday, title, onClick, clickable };
    });

    return dayNumbers;
  }, [activeTab, currentDate, setSearchParams]);

  const dayNumbers: Array<DayNumber> = useMemo(getDayNumbers, [getDayNumbers]);

  return {
    toPrevWeek,
    toNextWeek,
    dayNumbers,
    openPreviewTaskModal,
    createTaskForRange,
    tasks: weeklyTasks,
    isLoading: isCalendarsTabsLoading,
  };
};
